import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/logs/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/models/logsModel.js
// module id = 15
// module chunks = 0